import React, { useState, useEffect } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { MapPin, ChevronDown } from "lucide-react";
import { useGetBranchesQuery } from "../redux/api/Branches/BranchesApi";

const LocationSelector = () => {
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [filteredBranches, setFilteredBranches] = useState([]);

  const {
    data: branchesData,
    isLoading,
    error,
  } = useGetBranchesQuery({ page: "" });

  useEffect(() => {
    if (branchesData?.success && branchesData?.data) {
      setFilteredBranches(branchesData.data);
      if (!selectedBranch && branchesData.data.length > 0) {
        setSelectedBranch(branchesData.data[0]);
      }
    }
  }, [branchesData]);

  const handleBranchSelect = (branch) => {
    setSelectedBranch(branch);
  };

  return (
    <div className="d-flex align-items-center">
      <Dropdown>
        <Dropdown.Toggle
          variant="link"
          id="branch-dropdown"
          className="d-flex align-items-center text-decoration-none border-0 bg-transparent p-0"
          style={{
            color: "#666",
            fontSize: "14px",
            boxShadow: "none",
          }}
        >
          <MapPin size={16} className="me-2" style={{ color: "#ff6b35" }} />
          <div>
            <div
              style={{
                fontSize: "12px",
                color: "#999",
                lineHeight: 1,
                marginBottom: "2px",
              }}
            >
              OUR BRANCH
            </div>
            <div
              style={{
                fontSize: "14px",
                color: "#333",
                fontWeight: "500",
                lineHeight: 1,
              }}
            >
              {selectedBranch
                ? selectedBranch.branchName.replace(/branch/i, "").trim()
                : "Select"}
            </div>
          </div>
          <ChevronDown size={14} className="ms-2" style={{ color: "#999" }} />
        </Dropdown.Toggle>

        <Dropdown.Menu style={{ minWidth: "200px" }}>
          {isLoading && (
            <Dropdown.Item disabled>
              <Spinner size="sm" animation="border" /> Loading...
            </Dropdown.Item>
          )}

          {error && (
            <Dropdown.Item disabled className="text-danger">
              Failed to load branches
            </Dropdown.Item>
          )}

          {!isLoading &&
            !error &&
            filteredBranches.map((branch) => (
              <Dropdown.Item
                key={branch._id}
                onClick={() => handleBranchSelect(branch)}
                active={selectedBranch?._id === branch._id}
              >
                {branch.branchName.replace(/branch/i, "").trim()}
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LocationSelector;
